import posthog from 'posthog-js'

export default {
  install(app) {
    posthog.init(process.env.VUE_APP_POSTHOG_KEY, {
      api_host: process.env.VUE_APP_POSTHOG_HOST,
      capture_pageview: false,
    })
    app.config.globalProperties.$posthog = posthog
  },
}
